import useAutosave from '../hooks/useAutosave'

const Autosave = ({ element = null, ...props }) => {
    useAutosave(props)
    return element
}

export default Autosave
